import { FC } from 'react';

import MultiSelect from '.';

const MultiSelectFormInput: FC<{
  onChange: (data: any) => void;
  value?: string;
  readOnly?: boolean;
  label: string;
  helperText?: string;
  options?: {
    label: string;
    value: string;
    color?: string;
  }[];
}> = ({ onChange, value, readOnly, label, helperText, options }) => {
  return (
    <>
      <legend className="sr-only">{label}</legend>
      <span className="block text-sm font-medium leading-6 text-gray-900">{label}</span>
      <span className="block text-sm leading-5 text-gray-500">{helperText}</span>
      <MultiSelect
        onChange={data => {
          if (onChange) onChange(data);
        }}
        prevData={value}
        readOnly={readOnly}
        options={options}
      />
    </>
  );
};

export default MultiSelectFormInput;
